import { createReducer } from '@reduxjs/toolkit';

import { IHint } from './interfaces';
import * as actions from './actions';

const initialState: IHint = {
  isShow: false,
};

export default createReducer(initialState, (builder) => builder
  .addCase(actions.showApply, (state) => {
    state.isShow = true;
  })
  .addCase(actions.hide, (state) => {
    state.isShow = false;
  })
  .addCase(actions.reshow, (state) => {
    state.isShow = false;
  }));
